import env from '.env.json';

export const slug = (string: string) => {
  let stringSlug = string.toLowerCase();

  //Đổi ký tự có dấu thành không dấu
  stringSlug = stringSlug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
  stringSlug = stringSlug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
  stringSlug = stringSlug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
  stringSlug = stringSlug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
  stringSlug = stringSlug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
  stringSlug = stringSlug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
  stringSlug = stringSlug.replace(/đ/gi, 'd');
  //Xóa các ký tự đặt biệt
  stringSlug = stringSlug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
  //Đổi khoảng trắng thành ký tự gạch ngang
  stringSlug = stringSlug.replace(/ /gi, '-');
  //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
  //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
  stringSlug = stringSlug.replace(/\-\-\-\-\-/gi, '-');
  stringSlug = stringSlug.replace(/\-\-\-\-/gi, '-');
  stringSlug = stringSlug.replace(/\-\-\-/gi, '-');
  stringSlug = stringSlug.replace(/\-\-/gi, '-');

  return stringSlug;
}

export const vocabularyUrlSlug = (vocabulary: string, code: string = 'vi') => {
  if (code == 'vi') {
    return `${slug(vocabulary)}-la-gi-phat-am-cach-dung`;
  }

  return `${(vocabulary)}-meaning-pronunciation-usage`;
}

export const countWords = (str = '') => {
  const arr = str.split(' ');

  return arr.filter(word => word !== '').length;
}

export const blobToBase64 = (blob) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export const decryptText = (str: string) => {
  if (!str) {
    return false;
  }
  var unicode = {
    '0': ['C7'], '1': ['O5'], '2': ['N4'], '3': ['G3'], '4': ['TH'], '5': ['YL'], '6': ['FB'],
    '7': ['AJ'], '8': ['KW'], '9': ['EU'], '.': ['2I'], 'C': ['0P'], 'U': ['1M'], 'E': ['6D']
  };
  for (var i in unicode) {
    for (var k in unicode[i]) {
      str = str.replace(new RegExp(unicode[i][k], 'g'), i);
    }
  }
  return str;
}

export const roundByStep = (value: number, step: number) => {
  step || (step = 1.0);
  var inv = 1.0 / step;
  return Math.round(value * inv) / inv;
}

export const maxText = (string: string, max: number) => {
  if (string?.length <= max) {
    return string;
  }

  return string?.slice(0, max) + '...';
}

export const updateAppName = (string = ''): string => {
  string = string.replace(/Learnenglish|learnenglish|learnEnglish/gi, env.APP_NAME)
                 .replace(/EnglishTopVN|englishtop|EnglishTop/gi, env.APP_NAME)
                 .replace(/\s+/g, " ")
                 .trim();

  return string;
}

export const convertStyleToObject = (styleString: string) => {
  if (!styleString) return {};

  return styleString.split(";").reduce((styleObj: Record<string, string>, styleProp) => {
    const [property, value] = styleProp.split(":").map((s) => s.trim());
    if (!property || !value) return styleObj;

    const camelCaseProperty = property.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
    styleObj[camelCaseProperty] = value;
    return Object.fromEntries(
      Object.entries(styleObj).filter(([key]) => !key.startsWith("background"))
    );
  }, {});
};

export const replaceClientImage = (string: string, title: string) => {
  let regex = new RegExp('<img .*?src="(.*?)"', "gi"), result;
  string = updateAppName(string);

  while ((result = regex.exec(string))) {
    const src = `${env.URL_APP_FILE || env.URL_API}/${result[1]}`;
    let newImage = result[0].replace(result[1], src);
    newImage = newImage.replace('<img ', `<img alt="${title}" longdesc="${env.ROOT_URL}"`);
    string = string.replace(result[0], newImage);
    return string;
  }
}

export const uuid = (): string => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}
